import Big from 'big.js'

// 计算工具类
export default {
  /**
   * 数值相加
   * 支持浮点型
   *
   * @param {number} number1 数值1
   * @param {number} number2 数值2
   * @returns {number} 计算后的值
   */
  plus(number1, number2) {
    return new Big(number1).plus(number2).toNumber()
  },
  /**
   * 数值相减
   *
   * @param {number} number1 数值1
   * @param {number} number2 数值2
   * @returns {number} 计算后的值
   */
  minus(number1, number2) {
    return new Big(number1).minus(number2).toNumber()
  },
  /**
   * 数值相除
   *
   * @param {number} number1 分子
   * @param {number} number2 分母
   * @returns {number} 计算后的值
   */
  divide(number1, number2) {
    return new Big(number1).div(number2).toNumber()
  },
  /**
   * 数值相乘
   *
   * @param {number} number1 数值1
   * @param {number} number2 数值2
   * @returns {number} 计算后的值
   */
  multiply(number1, number2) {
    return new Big(number1).times(number2).toNumber()
  },
  /**
   * 数值求和
   *
   * @param {Array<number>} numbers 数值数组
   * @returns {number} 和
   */
  sum(numbers) {
    const reducer = (previousValue, currentValue) => this.plus(previousValue, currentValue)

    return numbers.reduce(reducer, 0)
  },
  /**
   * 四舍五入
   *
   * @param {number} num 数值
   * @param {number} decimalPlaces 保留的小数点位数
   * @returns {number} 处理后的数值
   */
  round(num, decimalPlaces = 0) {
    let factor = Math.pow(10, decimalPlaces) // 10 的指数次幂，用于将数字乘以相应数量级
    return Math.round(num * factor) / factor // 四舍五入，然后除以数量级
  },
  /**
   * 向上取整到指定精度
   *
   * @param {number} num 数值
   * @param {number} decimalPlaces 保留的小数点位数
   * @returns {number} 处理后的数值
   */
  ceil(num, decimalPlaces = 0) {
    const multiplier = 10 ** decimalPlaces
    return Math.ceil(this.multiply(num, multiplier)) / multiplier
  },
  /**
   * 向下取整到指定精度
   *
   * @param {number} num 数值
   * @param {number} decimalPlaces 保留的小数点位数
   * @returns {number} 处理后的数值
   */
  floor(num, decimalPlaces = 0) {
    const multiplier = 10 ** decimalPlaces
    return Math.floor(this.multiply(num, multiplier)) / multiplier
  }
}
